import React, { Fragment, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import {
    DropdownToggle,
    DropdownMenu,
    Nav,
    Button,
    NavItem,
    NavLink,
    UncontrolledButtonDropdown,
} from 'reactstrap';

import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PerfectScrollbar from 'react-perfect-scrollbar';

import avatar from '../../../assets/utils/images/avatars/avatar.png';
import background from '../../../assets/utils/images/dropdown-header/abstract10.jpg';

import { useAuth } from '../../../Context/Auth/AuthContext';
import ReachOutLabels from '../../../enums/ReachOutLabels';

export default function UserBox() {
    const history = useHistory();
    const { logout, authenticated, currentGroup } = useAuth();
    const menuHandler = useRef();

    const handleLogout = useCallback(async () => {
        await logout();
        history.push('/');
    }, [logout, history]);

    const goToContactInfo = useCallback(async () => {
        history.push('/profile/contact-info');
        menuHandler.current.toggle();
    }, [history]);

    const goToChangePassword = useCallback(async () => {
        history.push('/profile/change-password');
        menuHandler.current.toggle();
    }, [history]);

    const goToChangeEmail = useCallback(async () => {
        history.push('/profile/change-email');
        menuHandler.current.toggle();
    }, [history]);

    const userInfo = () => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }

    const cutString = useCallback((string, maxLength = 10) => {
        string = String(string);
        if (string.length > maxLength) {
            string = string.slice(0, maxLength);
            string += '...';
        }        
        return string;
    }, []);

    const currentStatus = () => {
        if (currentGroup) {
            return (
                <Fragment>
                    <div className="widget-content-left  mr-3">
                        <div className="widget-heading">
                            {currentGroup.title}
                        </div>
                        <div className="widget-subheading">
                            {ReachOutLabels[currentGroup.role]}
                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <div className="widget-content-left  mr-3">
                        <div className="widget-heading">
                            {userInfo().name}
                        </div>
                        <div className="widget-subheading capitalize">
                            {ReachOutLabels[userInfo().role]}
                        </div>
                    </div>
                </Fragment>
            );
        }
    }

    return (
        <Fragment>
            <div className="header-btn-lg pr-0">
                <div className="widget-content p-0">
                    <div className="widget-content-wrapper">

                        {currentStatus()}

                        <div className="widget-content-left">
                            <UncontrolledButtonDropdown ref={menuHandler} >
                                <DropdownToggle
                                    color="link"
                                    className="p-0"
                                    
                                >
                                    <img
                                        width={42}
                                        className="rounded-circle"
                                        src={avatar}
                                        alt="User avatar"
                                    />
                                    <FontAwesomeIcon
                                        className="ml-2 opacity-8"
                                        icon={faAngleDown}
                                    />
                                </DropdownToggle>
                                <DropdownMenu
                                    right
                                    className="rm-pointers dropdown-menu-lg dropdown-header-box"
                                >
                                    <div className="dropdown-menu-header">
                                        <div className="dropdown-menu-header-inner bg-info">
                                            <div
                                                className="menu-header-image opacity-2"
                                                style={{
                                                    backgroundImage:
                                                        'url(' + background + ')',
                                                }}
                                            />
                                            <div className="menu-header-content text-left">
                                                <div className="widget-content p-0">
                                                    <div className="widget-content-wrapper">
                                                        <div className="widget-content-left mr-3">
                                                            <img
                                                                width={42}
                                                                className="rounded-circle"
                                                                src={avatar}
                                                                alt="User avatar"
                                                            />
                                                        </div>
                                                        <div className="widget-content-left">
                                                            <div className="widget-heading">
                                                                {userInfo().name}
                                                            </div>
                                                            <div className="widget-subheading opacity-8">
                                                                {cutString(userInfo().email, 20)}
                                                            </div>
                                                        </div>
                                                        <div className="widget-content-right mr-2">
                                                            <Button
                                                                className="btn-pill btn-shadow btn-shine"
                                                                color="focus"
                                                                onClick={
                                                                    handleLogout
                                                                }
                                                            >
                                                                Sign out
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="scroll-area-xs"
                                        style={{
                                            height: '150px',
                                        }}
                                    >
                                        <PerfectScrollbar>
                                            <Nav vertical>
                                                <NavItem className="nav-item-header">
                                                    My Account
                                                </NavItem>

                                                <NavItem>
                                                    <NavLink onClick={goToContactInfo}>
                                                        Contact Info
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={goToChangeEmail}>
                                                        Change Email
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink onClick={goToChangePassword}>
                                                        Change Password
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </PerfectScrollbar>
                                    </div>
                                </DropdownMenu>
                            </UncontrolledButtonDropdown>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
